var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExportLast = function SvgExportLast(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exportLast_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z",
    "data-name": "Rechteck 1177"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414a5f",
    clipPath: "url(#exportLast_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.313 12.8H.759a.4.4 0 0 0-.4.4v6.4a.4.4 0 0 0 .4.405h3.554a.4.4 0 0 0 .4-.4V13.2a.4.4 0 0 0-.4-.4m-.4.806v5.6H1.162V13.6Z",
    "data-name": "Pfad 1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.264 8.53H10.71a.4.4 0 0 0-.4.4V19.6a.405.405 0 0 0 .4.4h3.554a.4.4 0 0 0 .4-.4V8.934a.4.4 0 0 0-.4-.404m-3.151 10.663V9.337h2.748v9.856Z",
    "data-name": "Pfad 1228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.289 4.265H5.735a.4.4 0 0 0-.4.4V19.6a.4.4 0 0 0 .4.4h3.554a.405.405 0 0 0 .4-.4V4.669a.405.405 0 0 0-.4-.404m-.4.807v14.121h-2.75V5.072Z",
    "data-name": "Pfad 1229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.241 0h-3.555a.4.4 0 0 0-.4.4v19.2a.4.4 0 0 0 .4.4h3.555a.4.4 0 0 0 .4-.4V.4a.4.4 0 0 0-.4-.4m-.4.808v18.387H16.09V.808Z",
    "data-name": "Pfad 1230"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExportLast);
export default ForwardRef;